export default __webpack_public_path__ + "static/media/IBBANIs.2d6fefe6.png";